import {
  IconButton,
  IconLoadingSpinner,
  IconTrash,
  Typography,
  mediumBodyTypography,
} from '@leaftrade/leaftrade-component-library';
import PropTypes from 'prop-types';
import React from 'react';
import { useDispatch } from 'react-redux';
import { toggleQuickOrderDeleteModal } from '../../../store/actions/storefrontActions';
import { currencyFormatter } from '../../../utils';

export const QuickOrderQuantityTotalCell = ({ item }) => (
  <Typography align='center' bodyStyle={mediumBodyTypography}>
    {item.selectedLocationCount || 0}
  </Typography>
);

export const QuickOrderSubtotalCell = ({ item }) => (
  <Typography align='center' bodyStyle={mediumBodyTypography}>
    {currencyFormatter.format(item.selectedLocationTotal || 0)}
  </Typography>
);

export const QuickOrderDeleteCell = ({ item }) => {
  const dispatch = useDispatch();

  return (
    <IconButton
      icon={<IconTrash />}
      onClick={() =>
        dispatch(
          toggleQuickOrderDeleteModal({
            item,
            isOpen: true,
          })
        )
      }
      size='small'
      tabIndex={-1}
      testingId='quick-order-delete-cell--button'
      tooltipLabel={`Remove ${item.productName}`}
      tooltipPlacement='left'
      variant='destructive'
    />
  );
};

export const QuickOrderLoadingCell = () => <IconLoadingSpinner />;

const itemPropType = PropTypes.shape({
  productName: PropTypes.string,
  selectedLocationCount: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  selectedLocationTotal: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
});

QuickOrderQuantityTotalCell.propTypes = {
  item: itemPropType.isRequired,
};

QuickOrderSubtotalCell.propTypes = {
  item: itemPropType.isRequired,
};

QuickOrderDeleteCell.propTypes = {
  item: itemPropType.isRequired,
};
